import { render, staticRenderFns } from "./distributor-info.vue?vue&type=template&id=3e429284&scoped=true&"
import script from "./distributor-info.vue?vue&type=script&lang=tsx&"
export * from "./distributor-info.vue?vue&type=script&lang=tsx&"
import style0 from "./distributor-info.vue?vue&type=style&index=0&id=3e429284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e429284",
  null
  
)

export default component.exports